import { Link } from 'react-router-dom';
import './style.scss';

function ContentCircles () {
    return(
        <section className='content-circles'>
            <div className='container'>
                <div className='feature-row'>
                    <div className='feature'>
                        <img src='/img/Foto%2010.jpeg' alt='' className='image'/>
                        <h2 className='headline'>
                            Versiegelung
                        </h2>
                        <p className='price'>
                                Ab 500€
                            </p>
                            <Link to={'/contact'}>
                                <button className='button'>
                                    Kontakt
                                </button>
                            </Link>
                        <p className='description'>                 
                            Durch unsere hochwertige Lackversiegelung wird die Oberfläche Ihres Autos vor Umwelteinflüssen wie Schmutz, UV-Strahlen und Wasserflecken geschützt. Das Ergebnis: eine glänzende, pflegeleichte Karosserie, die ihren Wert lange behält. Lassen Sie Ihr Auto von unseren Experten versiegeln und genießen Sie den langanhaltenden Schutz und die makellose Optik. Vereinbaren Sie jetzt einen Termin für Ihre professionelle Versiegelung und sorgen Sie für den perfekten Schutz Ihres Fahrzeugs!                        
                        </p>
                    </div>
                    <div className='feature best'>
                        <img src='/img/Foto%2011.JPG' alt='' className='image'/>
                        <h2 className='headline'>
                            Politur
                        </h2>
                        <p className='price'>
                            Ab 250€
                        </p>
                        <Link to={'/contact'}>
                            <button className='button'>
                                Kontakt
                            </button>
                        </Link>
                        <p className='description'>
                        Die Politur bei Magic Tech verleiht Ihrem Fahrzeug ein frisches, strahlendes Aussehen. Mit unserer professionellen Behandlung werden feine Kratzer und matte Stellen schonend entfernt, was den Lack langlebig schützt und gleichzeitig beeindruckenden Glanz erzeugt. Dadurch bleibt Ihr Auto nicht nur länger sauber, sondern gewinnt auch an Wert. Vertrauen Sie auf unsere Expertise und gönnen Sie Ihrem Fahrzeug eine erstklassige Politur. Buchen Sie jetzt und erleben Sie den Unterschied!                        
                        </p>                        
                    </div>
                    <div className='feature'>
                        <img src='/img/Foto%2012.JPG' alt='' className='image'/>
                        <h2 className='headline'>
                            Innenraumreinigung
                        </h2>
                        <p className='price'>
                            Ab 150€
                        </p>
                        <Link to={'/contact'}>
                            <button className='button'>
                                Kontakt
                            </button>
                        </Link>
                        <p className='description'>
                            Bei der gründlichen Innenraumreinigung entfernen wir jeglichen Schmutz aus dem Innenraum Ihres Fahrzeugs. Polster, Teppiche und Oberflächen werden sauber und frisch hinterlassen, sodass Ihr Auto innen wie neu erstrahlt. Für ein genaues Angebot bitten wir Sie, uns zu kontaktieren!
                        </p>
                    </div>
                </div>
                <div className='feature-row'>
                    <div className='feature'>
                        
                        <img src='/img/mtschnellpackung.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                           Innen- + Außenreinigung
                        </h2>
                        <p className='price'>
                            Ab 200€
                        </p>
                        <Link to={'/contact'}>
                            <button className='button'>
                                Kontakt
                            </button>
                        </Link>
                        <p className='description'>                 
                        Unser beliebtestes Servicepaket von Magic Tech bietet Ihrem Auto eine Rundum-Pflege für strahlende Sauberkeit. Mit unserer Innenreinigung entfernen wir hartnäckigen Schmutz und Staub aus dem Innenraum, während die Außenreinigung für ein makelloses Äußeres sorgt.
                        </p>
                        
                    </div>
                    <div className='feature best'>
                        <img src='/img/Foto%2014.JPG' alt='' className='image'/>
                        <h2 className='headline'>
                        Innen- + Außenreinigung + Glanzpolitur
                        </h2>
                        <p className='price'>
                            Ab 300€
                        </p>
                        <Link to={'/contact'}>
                            <button className='button'>
                                Kontakt
                            </button>
                        </Link>
                        <p className='description'>
                            Unser beliebtestes Servicepaket von Magic Tech bietet Ihrem Auto eine Rundum-Pflege für strahlende Sauberkeit. Mit unserer Innenreinigung entfernen wir hartnäckigen Schmutz und Staub aus dem Innenraum, während die Außenreinigung für ein makelloses Äußeres sorgt. Zum krönenden Abschluss verleiht die Glanzpolitur Ihrem Fahrzeug einen tiefen Glanz und langanhaltenden Schutz. Perfekt für alle, die den Wert ihres Autos erhalten und gleichzeitig für einen glänzenden Auftritt sorgen möchten. Vereinbaren Sie jetzt Ihren Termin und bringen Sie den Glanz zurück auf die Straße!                        
                        </p>
                    </div>
                    <div className='feature'>
                        <img src='/img/Foto%2015.jpeg' alt='' className='image'/>
                        <h2 className='headline'>
                            Windschutzscheiben Reparatur
                        </h2>
                        <p className='price'>
                            Ab 80€
                        </p>
                        <Link to={'/contact'}>
                            <button className='button'>
                                Kontakt
                            </button>
                        </Link>
                        <p className='description'>
                            Wir bieten Ihnen eine zuverlässige Windschutzreparatur, die Ihre Fahrsicherheit garantiert. Unsere erfahrenen Techniker beseitigen schnell und effektiv Risse und Chips in Ihrem Windschutzscheibe, bevor sie zu größeren Problemen führen. Durch unsere hochwertigen Materialien und modernen Techniken stellen wir sicher, dass Ihre Scheibe schnell wieder in Top-Zustand ist. Warten Sie nicht, bis es zu spät ist – schützen Sie sich und Ihre Mitfahrer! Kontaktieren Sie uns noch heute für eine individuelle Beratung und ein unverbindliches Angebot!
                        </p>
                    </div>
                </div>
                <div className='feature-row'>
                    <div className='feature'>
                        <img src='/img/Foto%2016.jpeg' alt='' className='image'/>
                        <h2 className='headline'>
                            Scheinwerfer-Aufbereitung
                        </h2>
                        <p className='price'>
                            Ab 50€ / Stück
                        </p>
                        <Link to={'/contact'}>
                            <button className='button'>
                                Kontakt
                            </button>
                        </Link>
                        <p className='description'>
                            Matt gewordene, vergilbte oder blinde Scheinwerfer? Kein Grund für einen teuren Austausch – bringen Sie Ihr Fahrzeug zu uns! Bei MagicTech bieten wir professionelle Scheinwerfer-Aufbereitung an, mit der wir alte, verwitterte Scheinwerfer wieder wie neu erscheinen lassen. Unsere Dienstleistung verbessert nicht nur die Optik Ihres Fahrzeugs, sondern sorgt auch für deutlich bessere Sichtverhältnisse und mehr Sicherheit im Straßenverkehr. Vertrauen Sie uns – wir lassen Ihre Scheinwerfer wieder strahlen!                        
                        </p>                        
                    </div>
                    <div className='feature best'>
                        <img src='/img/Foto%2017.JPG' alt='' className='image'/>
                        <h2 className='headline'>
                            Reperatur und Service
                        </h2>
                        <p className='price' style={{fontSize:'18px', marginBottom:'25px'}}>
                            Der Preis hängt vom Zustand ab.
                        </p>
                        <Link to={'/contact'}>
                            <button className='button'>
                                Kontakt
                            </button>
                        </Link>
                        <p className='description'>
                            Magic Tech Autopflege in Ternitz bietet professionelle Fahrzeugpflege, Reparaturen, Ölwechsel, Reifenservice und umfassenden Autoservice aus einer Hand. Mit modernster Technik, hochwertigen Produkten und viel Erfahrung sorgen wir dafür, dass Ihr Fahrzeug sicher, zuverlässig und bestens gepflegt bleibt. Qualität, Präzision und Kundenzufriedenheit stehen bei uns an erster Stelle. Vereinbaren Sie jetzt Ihren Termin bei Magic Tech – Ihr Auto wird es Ihnen danken!
                        </p>                     
                    </div>
                    <div className='feature'>
                        <img src='/img/Foto%2018.JPG' alt='' className='image'/>
                        <h2 className='headline'>
                            Sitze
                        </h2>
                        <p className='price'>
                            Ab 20€/Sitze
                        </p>
                        <Link to={'/contact'}>
                            <button className='button'>
                                Kontakt
                            </button>
                        </Link>
                        <p className='description'>
                            Suchen Sie nach einer zuverlässigen Sitzbezüge Reinigung? Bei Magic Tech in Ternitz bieten wir eine umfassende und professionelle Autoinnenreinigung, die den Komfort und die Ästhetik Ihres Fahrzeugs deutlich verbessert. Unsere Fachleute verwenden moderne Techniken und hochwertige Produkte, um Schmutz und Flecken effektiv zu entfernen und Ihren Sitzen neues Leben einzuhauchen. Schützen Sie das Material und erhöhen Sie den Wert Ihres Fahrzeugs! Vertrauen Sie auf unsere Expertise für eine makellose Innenausstattung. Jetzt anfragen für ein kostenloses Angebot! Für ein genaues Angebot bitten wir Sie, uns zu kontaktieren!                        
                        </p>                        
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContentCircles;